import type { HTMLComponentProps } from "@commercekit/react";

export const CKFormHiddenInputs = ({
  data,
}: HTMLComponentProps<{ data: [string, string][] }>) => (
  <>
    {data.map(([key, value]) => (
      <input key={key} type="hidden" name={key} value={value} />
    ))}
  </>
);
